import { fetcher } from "@/shared/core-configs";
import { ErpProductInput } from "../types/ErpProduct";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateStockError } from "@/core/common/types";
import { GET_ERP_PRODUCTS_FETCH_KEY } from "./useGetErpProducts";

export const toggleEnabledErpProduct = async (
  id: string,
  enabled: boolean,
): Promise<ErpProductInput> => {
  const response = await fetcher.patch(
    `${API.GESLUB}/erp-product/${id}/toggle-enabled`,
    { enabled },
  );
  return response.data;
};

export const useToggleEnabledErpProduct = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    ErpProductInput,
    UpdateStockError,
    { id: string; enabled: boolean }
  >({
    mutationFn: ({ id, enabled }) => toggleEnabledErpProduct(id, enabled),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ERP_PRODUCTS_FETCH_KEY],
      });
    },
  });
  return {
    mutate: mutation.mutate,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
};
